import React from 'react'
import ProductHero from '../components/ProductHero'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import AllProductsGrid from '../components/AllProductsGrid'
import ProductComparison from '../components/ProductComparison'
import B2BInquiry from '../components/B2BInquiry'
import Testimonials from '../components/Testimonials'
import CustomizationOptions from '../components/CustomizationOptions'
import QualityCertifications from '../components/QualityCertifications'
import FAQSection from '../components/FAQSection'

const Product = () => {
  return (
    <div>
        <Navbar/>
      <ProductHero/>
      <AllProductsGrid/>
      {/* <ProductComparison/> */}
      <CustomizationOptions/>
      <B2BInquiry/>
      
      <QualityCertifications/>
      <FAQSection/>
      <Footer/>
    </div>
  )
}

export default Product
